import React, { useState, useEffect } from 'react'
import {
  Button,
  Input,
  Icon,
  Accordion,
  Radio,
} from 'semantic-ui-react'
import { HTTP } from './../../../providers'
import { getClient } from './../../../utils/functions'
import { v4 as uuidv4 } from 'uuid'

const nameError = 'You must enter a name'
const categoryError = 'Please select a category'

const MetaData = ({ save, close, args }) => {
  const guid = args && args.metadata && args.metadata.guid
  const curName = args && args.metadata && args.metadata.name
  const curCategory = args && args.metadata && args.metadata.category
  const idParent = args && args.metadata && args.metadata.idParent
  const dateCreated = args && args.metadata && args.metadata.dateCreated
  const dateModified = args && args.metadata && args.metadata.dateModified

  const [name, setName] = useState(curName)
  const [category, setCategory] = useState(curCategory)
  const [tags, setTags] = useState({})
  const [row, setRow] = useState({})
  const [rowExists] = useState(
    args && args.metadata && args.metadata.guid
  )
  const [completed] = useState(false)
  const [error, setError] = useState('')
  const [merge, setMerge] = useState(false)
  const [activeIndex, setActiveIndex] = useState('')
  const [indexCount, setIndexCount] = useState(0)
  const [synced, setSynced] = useState('false')

  useEffect(() => {
    // Query count of templates using this row...
    const client = getClient()
    const message = `${client.demoAPI}/listMessageRows/${guid}`
    HTTP.get(message)
      .then(messages => {
        if (messages && messages.data && messages.data.length > 0) {
          setIndexCount(messages.data.length)
          setMerge(true)
        } else {
          setIndexCount(0)
        }
      })
      .catch(() => {
        setIndexCount(0)
      })
  }, [guid])

  // const toggleHandler = event => {
  //   setMerge(!merge)
  // }

  const inputchangedHandler = event => {
    setName(event.target.value)
  }

  const radioChangedHandler = (e, { value }) => {
    setSynced(value)
  }

  // const dropdownchangedHandler = (e, result) => {
  //   const { value } = result
  //   setCategory(value)
  // }

  // const onChangeTags = data => {
  //   setTags(data.tags)
  // }

  const validateForm = () => {
    setError('')
    if (name === '') {
      setError(nameError)
      return
    }
    if (category === '') {
      setError(categoryError)
      return
    }
  }

  const onHandleUpdate = () => {
    // FORM VALIDATION
    validateForm()

    // UPDATE METADATA AND ROW
    row.metadata = {
      name,
      guid,
      idParent,
      category,
      tags,
      dateModified: new Date(),
      dateCreated,
      merge
    }

    setRow(row)
    save(row.metadata)
  }

  const onHandleSaveAs = () => {
    // FORM VALIDATION
    validateForm()

    // UPDATE METADATA AND ROW
    row.metadata = {
      name,
      guid: uuidv4(),
      idParent: guid,
      category,
      tags,
      dateCreated: new Date(),
      dateModified,
      merge
    }

    setRow(row)
    save(row.metadata)
  }

  const onHandleSave = () => {
    const guid = uuidv4()

    // FORM VALIDATION
    validateForm()

    // UPDATE METADATA AND ROW
    row.metadata = {
      name,
      guid,
      idParent: '',
      category,
      tags,
      dateCreated: new Date(),
      dateModified,
      merge,
      synced,
    }

    setRow(row)
    save(row.metadata)
  }

  const onHandleCompleted = () => {
    save(row.metadata)
  }

  const onHandleClose = () => {
    close()
  }

  const NewRow = () => {
    return (
      <>
        <Input
          label={{ icon: 'asterisk' }}
          labelPosition='right corner'
          type='text'
          placeholder='Write a row name'
          onChange={inputchangedHandler}
          style={{ width: '100%', paddingBottom: '10px' }}
          value={name}
          autoFocus
        />
        <p style={{ color: 'black' }}>Save this row as</p>
        <div>
          <Radio
            label='Synced'
            name='radioGroup'
            value='true'
            checked={synced === 'true'}
            onChange={radioChangedHandler}
          />
        </div>
        <p style={{
          fontSize: '12px',
          color: '#666666',
          padding: '0.85714em',
          paddingLeft: '1.85714em'
        }}>
          Content that you can use again and needs to be synced. When you edit it, changes propagate to other designs that use the same content.
        </p>
        <div>
          <Radio
            label='Standard'
            name='radioGroup'
            value='false'
            checked={synced === 'false'}
            onChange={radioChangedHandler}
          />
        </div>
        <p style={{
          fontSize: '12px',
          color: '#666666',
          padding: '0.85714em',
          paddingLeft: '1.85714em'
        }}>
          Content that you can use again and doesn't need to be synced.
          When you edit it, changes don't affect other designs using the same content.
        </p>

        {/* <Dropdown
					placeholder='Select a category'
					style={{ width: '100%', fontWeight: 'normal' }}
					onChange={dropdownchangedHandler}
					selection
					options={categories}
					value={category}
				/>

				<Tags tags={tags} onChangeTags={onChangeTags} /> */}

        <div style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}>
          <SaveActions />
        </div>
      </>
    )
  }

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  const FormDetails = () => {
    return (
      <>
        <Input
          label={{ icon: 'asterisk' }}
          labelPosition='right corner'
          type='text'
          placeholder='Write a row name'
          onChange={inputchangedHandler}
          style={{ width: '100%', paddingBottom: '10px' }}
          value={name}
          autoFocus
        />

        {/* <Dropdown
					placeholder='Select a category'
					style={{ width: '100%', fontWeight: 'normal' }}
					onChange={dropdownchangedHandler}
					selection
					options={categories}
					value={category}
				/>

				<Tags tags={tags} onChangeTags={onChangeTags} /> */}
      </>
    )
  }

  const OptionalDetails = () => {
    return (
      <Accordion>
        <Accordion.Title
          index={0}
          onClick={handleClick}
          style={{ fontSize: '11px', paddingBottom: '10px' }}
        >
          <Icon name='dropdown' />
          Optional details
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <FormDetails />
        </Accordion.Content>
      </Accordion>
    )
  }

  const ExistingRow = () => {
    return (
      <div style={{ textAlign: 'center', color: 'black' }}>
        {
          indexCount && (parseInt(indexCount) > 1)
            ? (
              <>
                <IndexStatus />
                <OptionalDetails />
              </>
            ) : (
              <FormDetails />
            )
        }

        <SaveActions />
      </div>
    )
  }

  const SaveRowViews = () => {
    return (
      <div id='builder'>{rowExists ? <ExistingRow /> : <NewRow />}</div>
    )
  }

  const Completed = () => {
    return (
      <>
        <div
          style={{ width: '100%', textAlign: 'center', marginBottom: '5px' }}
        >
          <Icon circular name='checkmark' size='big' />
        </div>

        <div
          className='actions'
          style={{ width: '100%', textAlign: 'center', marginTop: '5px' }}
        >
          <Button onClick={onHandleCompleted}>
            <i className='chevron circle right icon'></i> Continue
          </Button>
        </div>
      </>
    )
  }

  const ErrorMessages = () => {
    return (
      <div
        className='actions'
        style={{
          color: 'red',
          width: '100%',
          textAlign: 'center',
          marginTop: '5px'
        }}
      >
        {error}
      </div>
    )
  }

  // const MergeCheckbox = () => {
  //   return (
  //     <>
  //       <Checkbox
  //         label='Apply changes to all templates containing this row.'
  //         onChange={toggleHandler}
  //         checked={merge}
  //       />
  //     </>
  //   )
  // }

  const IndexStatus = () => {
    return (
      <>
        {indexCount && indexCount > 1 ? (
          <div>This row is used by {indexCount} other messages.</div>
        ) : (
          <div>This row is used by one other message.</div>
        )}
        <div>Would you like to update all messages with this version.</div>
      </>
    )
  }

  const SaveActions = () => {
    const labelUpdate =
      indexCount && indexCount > 1 ? 'Yes, update all' : 'Update row'
    return (
      <div
        className='actions'
        style={{ marginTop: '15px', marginBottom: '15px' }}
      >
        {rowExists ? (
          <>
            <Button onClick={onHandleUpdate} primary>
              <i className='edit icon black'></i> {labelUpdate}
            </Button>

            <Button onClick={onHandleSaveAs} secondary>
              <i className='save icon'></i> Create a new version
            </Button>

            <Button onClick={onHandleClose}>
              <i className='close icon'></i> Cancel
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onHandleSave} secondary>
              <i className='save icon'></i> Save
            </Button>
            <Button onClick={onHandleClose}>
              <i className='close icon'></i> Cancel
            </Button>
          </>
        )}
      </div>
    )
  }

  return (
    <>
      {completed ? <Completed /> : <SaveRowViews />}
      <ErrorMessages />
    </>
  )
}

export default MetaData
